import React from 'react';
import Review from './review';
import '../css/Service.css';

function OrganicWaste() {
  return (
    <div className="service-page">
      <div className="service-banner">
        <img src={'/img_7.jpg'} alt="Organic Waste Banner" className="service-banner-img" />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Organic Waste</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>ORGANIC WASTE</h1>
        <p>
          We provide collection, recycling and responsible management solutions for organic wastes from food service, landscaping, and wood streams.
        </p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>Organic waste streams include:</h2>

          <h3>1. Food Waste</h3>
          <ul className="feature-list">
            <li>Sandwiches, cheese, vegetables, fruits, fast food</li>
            <li>Chicken, meat, beef, bread, rice</li>
            <li>And many more...</li>
          </ul>

          <h3>2. Food Soiled Paper</h3>
          <ul className="feature-list">
            <li>Coffee filters, tea bags, food packing material</li>
            <li>Paper cups, napkins, paper towels, tissues, wrappers</li>
            <li>Egg cartons, paper plates, and more</li>
          </ul>

          <h3>3. Non-Hazardous Wood Waste (unpainted & untreated)</h3>
          <ul className="feature-list">
            <li>Cardboard, lumber, pallets, plywood</li>
            <li>And many more...</li>
          </ul>

          <h3>4. Green Waste</h3>
          <ul className="feature-list">
            <li>Cut flowers, grass, leaves, branches, weeds</li>
            <li>And many more...</li>
          </ul>

          <p>
            We help businesses divert organic material from landfill through composting, anaerobic digestion, and other beneficial reuse programs. Ask us about program design, collection frequency, and cost-saving options.
          </p>

          <div className="service-cta">
            <a href="/contact" className="btn btn-primary">Request Organic Waste Services</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="specialty-card">
            <h3>Program Benefits</h3>
            <ul className="specialty-list">
              <li>Reduce landfill fees and greenhouse gas emissions</li>
              <li>Access to composting and biogas partners</li>
              <li>Customized collection and reporting</li>
              <li>Employee training and contamination control</li>
            </ul>
          </div>
        </aside>
      </section>

      <Review />
    </div>
  );
}

export default OrganicWaste;
